import { ChangeEventHandler, ReactElement } from "react";
import { RegisterOptions } from "react-hook-form";
import { emailValidate } from "~/validator/email";

export const EmailField = ({
  register,
  errors,
  onChange,
}: {
  register: (ref: string, options: RegisterOptions) => any;
  errors: Record<string, any>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}): ReactElement => {
  return (
    <div className="field">
      <label>
        <span className="label">メールアドレス</span>
        <input
          type="email"
          placeholder="mail@example.com"
          data-test="input-email"
          {...register("email", {
            required: true,
            validate: async (value) => await emailValidate(value),
          })}
          onChange={onChange}
        />
        {errors.email?.type == "required" && <span className="sub red">メールアドレスを入力してください。</span>}
        {errors.email?.type == "validate" && <span className="sub red">メールアドレスの形式が正しくありません。</span>}
      </label>
    </div>
  );
};
